module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e144017"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Henr_9781401686307_epub_c7.5_r1#d6e2",
      "id": "d7e2"
    }
  }, [_c('b', [_vm._v("CHAPTER 2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e144517"
    }
  }, [_c('span', [_c('span', {
    staticClass: "dcap2",
    attrs: {
      "id": "d14e628"
    }
  }, [_vm._v("I ")]), _vm._v("can see why Cassidy likes this place,” Allison Pierce said as she lifted a tortilla chip laden with bean dip to her mouth. She bit down with a satisfying crunch.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e146217"
    }
  }, [_c('span', [_vm._v("Puerto Marquez was a wild riot of colors, from the purple carpet to the bright seascape murals decorating the walls. Each of the restaurant’s chairs was a different color of the rainbow—green, purple, orange, yellow—and the backs were covered with paintings of flowers and birds.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e148117"
    }
  }, [_c('span', [_vm._v("The sounds were nearly as overwhelming as the colors: Mexican folk music drifting from the kitchen fought with Spanish-language infomercials playing on two of the dining room’s big-screen televisions. The other two TVs were broadcasting Spanish telenovelas with the sound turned down. Overlaying the music and advertisements was the rattle of three aging air conditioners turned on full blast.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e150417"
    }
  }, [_c('span', [_vm._v("Nicole Hedges nodded, looking a little shell-shocked. Whenever it was Nicole’s turn to choose a restaurant for the three of them, she tended to pick places where the loudest sound was the clink of ice cubes.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e152117"
    }
  }, [_c('span', [_vm._v("Puerto Marquez was located in a strip mall in a less-than-glamorous part of outer Southeast Portland. Without Cassidy’s recommendation, Allison wouldn’t have given the place a second look, but their friend had sworn that the restaurant had the best Mexican food in Portland. It didn’t hurt that free chips, salsa, and refried beans had appeared on their table as soon as they sat down.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e154818"
    }
  }, [_c('span', [_vm._v("Allison thumbed through the huge menu, pages and pages encased in clear plastic. Despite the aggressive air-conditioning, her fingers slid on the pages. It was nearly eight o’clock, and she bet the temperature outside still hadn’t dropped below eighty-five. Because of the heat, she had left most of what she thought of as her “court uniform” in the car—the suit jacket, white blouse, and pumps—and was now wearing just a white camisole, a dark blue skirt, and flip-flops. Her hair was still pinned up from this morning, but tendrils kept falling in front of her eyes or, more annoyingly, finding their way between her lips.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e158318"
    }
  }, [_c('span', [_vm._v("She hooked a strand out of the corner of her mouth and took another sip of her margarita, wondering just how late Cassidy would be. Maybe she’d sent a second text? But when Allison checked her phone again, there was nothing new.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e159918"
    }
  }, [_c('span', [_vm._v("Nicole put her hand on Allison’s wrist. At the touch of her cool fingers, Allison set her phone back on the table.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e160918"
    }
  }, [_c('span', [_vm._v("“Stop checking,” Nicole said. “You know that in ten or twenty minutes Cassidy will come running in, knocking some poor customer in the head with that big old black tote of hers. That girl is always late.” As she spoke, Nic managed to dip a tortilla chip into the bean dip and the salsa without snapping it in half.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e162918"
    }
  }, [_c('span', [_vm._v("Nicole’s description of Cassidy was on the money. Cassidy was always multitasking, always looking for a shortcut, always in a hurry, and always, as Nicole had said, late.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e164218"
    }
  }, [_c('span', [_vm._v("“Maybe I should start telling her we’re meeting half an hour earlier than we really are,” Allison suggested. “That way she might actually be on time for a change.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e165919"
    }
  }, [_c('span', [_vm._v("Nicole shook her head. “The leopard doesn’t change its spots. Cassidy is Cassidy, and that means she’s always late. It means a lot of other things too, but right now it means we shouldn’t wait for her before we place our order.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e167719"
    }
  }, [_c('span', [_vm._v("The three of them had been friends for six years, though they had been acquainted with each other for much longer. Sixteen years earlier they had graduated from Catlin Gabel, one of Portland’s elite private schools. In high school they had barely known each other. Cassidy had been a cheerleader. Nicole had stood out by virtue of being one of the fewer than a half-dozen African American students. And Allison had captained the debate team.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e170719"
    }
  }, [_c('span', [_vm._v("At their ten-year high school reunion, the three women realized they now had something more than an alma mater in common: crime. Cassidy covered it for Channel Four, Nicole investigated it for the FBI, and Allison prosecuted it for the federal government. At the time, Nicole had been working out of the Denver FBI field office, but a few months later she was transferred back to Portland and started working cases with Allison.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e173519"
    }
  }, [_c('span', [_vm._v("Soon after, the three women met for dinner, and a friendship began over a shared dessert called Triple Threat Chocolate Cake. In its honor, they had half jokingly christened themselves the Triple Threat Club. Now whenever they got together they always ordered the most decadent dessert on the menu—but just one serving, and three forks.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e176019"
    }
  }, [_c('span', [_vm._v("Allison wasn’t sure, since most of Puerto Marquez’s menu was in Spanish with no translation, but she thought the only dessert available here might be a flan.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e177419"
    }
  }, [_c('span', [_vm._v("Their waiter came up, and the two women ordered. After he left, Nicole said, “Some idiot almost ran me over today.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e178419"
    }
  }, [_c('span', [_vm._v("“What?” Allison straightened up.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e179420"
    }
  }, [_c('span', [_vm._v("“Yeah, I was out for a run at lunch, and some guy in an old beater came out of nowhere.” Raising her hands, Nicole made a shoving motion. “I managed to push myself off his hood. Somehow I stayed on my feet and made it to the other side of the car. I’m lucky he didn’t break my legs, or worse. As it is, I know I’m going to be really stiff tomorrow.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e181720"
    }
  }, [_c('span', [_vm._v("Despite the air-conditioning, Allison shivered. “Did you get his license plate number?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e182720"
    }
  }, [_c('span', [_vm._v("Nicole grimaced. “The car was filthy. There was mud all over the plate.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e183720"
    }
  }, [_c('span', [_vm._v("Allison replayed her friend’s words. “Wait—did you say you were running? It must have been ninety degrees by lunchtime.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e184720"
    }
  }, [_c('span', [_vm._v("The city was on the second day of over one-hundred-degree temperatures, and coping poorly. While most businesses had air-conditioning, a lot of older homes didn’t. It was also an oddly muggy heat for Portland, which usually didn’t have much humidity. The weathermen had promised a thunderstorm the night before, but it never came.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e187120"
    }
  }, [_c('span', [_vm._v("Nicole shrugged. “Lunch is the only free time I have. It’s not that bad if you wear sunglasses and drink lots of water.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e188120"
    }
  }, [_c('span', [_vm._v("“I’ll take your word for it. I can’t stand this heat much longer.” Allison made a face. “When I got in my car to come here it was like getting into a blazing oven. A blazing oven that was on fire. Inside a volcano.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e189920"
    }
  }, [_c('span', [_vm._v("Nicole smiled. “Don’t you guys have air-conditioning at home?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e190420"
    }
  }, [_c('span', [_vm._v("“Only in our bedroom. It’s either turn the air-conditioning on and listen to it rattle, or turn it off and baste in your own sweat.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e191420"
    }
  }, [_c('span', [_vm._v("Nicole took another sip of her margarita. “Which one are you—the one who prefers silence or the one who would rather be cool?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e192420"
    }
  }, [_c('span', [_vm._v("“We alternate.” Allison pushed a piece of hair out of her eyes. She was starting to sweat again just thinking about it. “One hour I just want to cool off and who cares about the noise, only Marshall can’t take it. The next hour I’m the one who can’t stand listening to the fan bang around in that metal box, and Marshall’s the one begging to turn it back on.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e195121"
    }
  }, [_c('span', [_vm._v("Nicole sighed. “I’ve been sleeping in the basement on a cot. I’m just thankful that Makayla’s at that sleepaway camp. It’s always cool at the coast.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e196421"
    }
  }, [_c('span', [_vm._v("“You must miss her a lot,” Allison said. “Is it hard to have an empty house?”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e197421"
    }
  }, [_c('span', [_vm._v("“I do miss her.” Nicole took another sip of ice water. “At the same time, it’s a nice break not to be juggling child care or asking my parents to keep her for the night when something breaks. And if I come home too tired to do anything but eat a bowl of cereal, I don’t feel guilty for not serving a meal made from however many food groups there are now.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e199721"
    }
  }, [_c('span', [_vm._v("Talking about food made Allison think about Cassidy. She checked her watch again. Cassidy was now forty-five minutes late—a record, even for her.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e201121"
    }
  }, [_c('span', [_vm._v("Their food came. Allison had ordered spicy shrimp with a side of rice and beans. The shrimp made her sweat too, but with the air-conditioning and the ice water and the margarita, she didn’t mind. Every bite or two, she glanced at the front door.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e202921"
    }
  }, [_c('span', [_vm._v("“I’m going to call her again,” she said when her plate was half empty, already pressing buttons on her phone. After four rings, Cassidy’s voice mail kicked in. Disconnecting the call, Allison said slowly, “She doesn’t have a new boyfriend, does she?” It was the only reason she could think of why their friend wouldn’t even pick up.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e204821"
    }
  }, [_c('span', [_vm._v("“Not that I know of.” Nicole shrugged. “But you know Cassidy—that can change in a minute.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e206122"
    }
  }, [_c('span', [_vm._v("“One thing that will never change is how much she likes her phone. You know she’ll always answer. It doesn’t matter whether she’s sleeping or sick or super busy.” They sometimes joked that Cassidy should just cut out the middleman and have her phone surgically implanted. “So why isn’t she answering now? It’s not like she’s on the line and it’s going straight to voice mail. It’s like it’s ringing and no one is answering.” The shrimp Allison had eaten felt like they were alive and squirming in her gut. “Nic—I think something’s wrong.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e209022"
    }
  }, [_c('span', [_vm._v("“Let’s give it five more minutes,” Nicole said. “If she doesn’t show by then, we’ll see if we can track her down.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46144884","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Henr_9781401686307_epub_c9_r1.vue
// module id = 84
// module chunks = 0